
import photo1 from 'url:./img/Slide1.JPG';
import photo2 from 'url:./img/Slide2.JPG';
import photo3 from 'url:./img/Slide3.JPG';
import photo4 from 'url:./img/Slide4.JPG';
import photo5 from 'url:./img/Slide5.jpeg';
import photo6 from 'url:./img/IMG_3376.jpg';
import photo7 from 'url:./img/IMG_3104.jpg';

import videoThumbRick from 'url:./img/rickroll.jpg';

import partnerLogoMicroIT from 'url:./img/medpart-microit.png';
import partnerLogoLikista from 'url:./img/medpart-likista.png';
import partnerLogoInfoSV from 'url:./img/medpart-infosvipb.png';
import partnerLogoInfoSEI from 'url:./img/sponsor-sei.png';
import partnerLogoSmartfren from 'url:./img/sponsor-smartfren.svg';


const mediaContent = {
  "blogArticles": [
    {
      "id": "artikel-1",
      "title": "More Than Just Aesthetics: How Minimalist Digital Posters Can Combat Information Overload",
      "date": "17 May 2026",
      "author": "Muzzayan & Hanuna",
      "summary": "Minimalist digital posters help audiences focus on important messages by reducing visual noise and improving information retention.",
      "image": "https://placehold.co/600x400/3B82F6/FFFFFF?text=Minimalist+Poster&font=montserrat",
      "link": "/blog-detail?id=artikel-1",
      "fullContentHTML":
      `
        <p>In today’s digital era, people are constantly surrounded by massive amounts of information from social media, advertisements, and online platforms. As a result, audiences often experience information overload, making it difficult to focus on important messages. Minimalist digital posters offer a solution by presenting information in a clean, simple, and visually balanced way.</p>

        <p>Minimalism in digital posters is not only about visual aesthetics, but also about communication efficiency. Minimalism is a sophisticated cognitive strategy. By intentionally utilizing whitespace, bold typography, and a restricted color palette, minimalist design strips away the digital noise to amplify the core message, providing psychological relief to the viewer and drastically boosting information retention.</p>

        <p>A simple design can create a stronger emotional impact and improve message retention among viewers. By reducing unnecessary elements, designers are able to direct audience attention toward the core message.</p>
      `
    },
    {
      "id": "artikel-2",
      "title": "Motion Graphics: The Future of Social Advocacy",
      "date": "17 May 2026",
      "author": "Muzzayan & Hanuna",
      "summary": "Motion graphics transform complex social issues into engaging visual stories capable of inspiring empathy and action.",
      "image": "https://placehold.co/600x400/EC4899/FFFFFF?text=Motion+Graphics&font=montserrat",
      "link": "/blog-detail?id=artikel-2",
      "fullContentHTML":
      `
        <h2>Motion Graphics Trend</h2>

        <p>Traditional advocacy often gets lost in the fast-scrolling world of modern social media. The solution? Motion graphics. By mixing dynamic visuals, text, and sound, they turn heavy data and complex social issues into captivating, bite-sized stories. They beat the algorithms, grab attention from the very first second, and make crucial messages impossible to scroll past.</p>

        <h2>Building an Emotional Bridge</h2>

        <p>Beyond simply stopping the scroll, motion graphics spark real empathy and action. Scientifically, visual storytelling bypasses language barriers and triggers an immediate emotional response. This builds a powerful bridge between activists and the public, transforming passive viewers into active participants who donate, sign petitions, and educate others.</p>

        <p>Because they are perfectly built for sharing across platforms like Instagram, TikTok, and LinkedIn, these visually driven advocacy campaigns possess the unique power to go global instantly.</p>

        <h2>Why Motion Graphics Work</h2>

        <p>They balance visual harmony with functional clarity. In events like Portal 8, motion graphics perfectly embody the “Beyond Creativity” approach. It is no longer just about making visuals aesthetically pleasing; it is about taking an abstract issue and turning it into a solution, or “From Ideas to Digital Impact”.</p>

        <p>By participating in formats like the Animated Video Campaign, creators can communicate complex future challenges in a structured, elegant way. Motion graphics aren’t just a fleeting trend; they are the future of driving tangible social change.</p>
      `
    },
    {
      "id": "artikel-3",
      "title": "Future-Proofing Your Career: Why Digital Fluency is the New Currency for Gen Z",
      "date": "17 May 2026",
      "author": "Muzzayan & Hanuna",
      "summary": "Digital fluency has become an essential skill for Gen Z to survive and thrive in the rapidly evolving future workforce.",
      "image": "https://placehold.co/600x400/F97316/FFFFFF?text=Digital+Fluency&font=montserrat",
      "link": "/blog-detail?id=artikel-3",
      "fullContentHTML":
      `
        <p>In today’s rapidly evolving world, having digital fluency is no longer just an advantage — it has become a necessity. As the first generation to grow up fully surrounded by technology, digital skills are now the “new currency” that determines career opportunities and long-term success for Gen Z.</p>

        <p>Traditional degrees are no longer the sole ticket to a secure career. Today, employers look for a hybrid skill set. Whether you are in marketing, agriculture, finance, or engineering, technology intersects with every industry. Understanding automation tools, basic data visualization, and AI-driven platforms will set a candidate apart from the competition.</p>

        <p>While Gen Z is famously labeled as “digital natives,” there is a significant difference between digital literacy and digital fluency. Literacy is knowing how to use a tool; fluency is knowing when, why, and how to leverage that tool to create value.</p>

        <p>Ultimately, digital fluency is the ultimate shield against an unpredictable job market. By mastering this currency, Gen Z can transform technological disruption into personal opportunity, ensuring they don’t just survive the future of work, but drive it.</p>
      `
    }
  ],
  "gallery": {
    "photos": [
      {
        "id": "foto-1", "title": "Guest Speaker Session", "year": "2024",
        "thumbnailUrl": photo1, "fullUrl": photo1,
        "description": "Guest speaker Kevin Anggara sharing insights during the Portal 6 talkshow."
      },
      {
        "id": "foto-2", "title": "Certificate of Appreciation", "year": "2024",
        "thumbnailUrl": photo2, "fullUrl": photo2,
        "description": "Presenting a certificate of appreciation to guest speaker Kevin Anggara."
      },
      {
        "id": "foto-3", "title": "Audience Engagement", "year": "2024",
        "thumbnailUrl": photo3, "fullUrl": photo3,
        "description": "The audience listening intently during a Portal 6 seminar session."
      },
      {
        "id": "foto-4", "title": "Q&A Session", "year": "2024",
        "thumbnailUrl": photo4, "fullUrl": photo4,
        "description": "The Q&A session in full swing, fostering interactive discussion."
      },
      {
        "id": "foto-5", "title": "Participant Registration", "year": "2024",
        "thumbnailUrl": photo5, "fullUrl": photo5,
        "description": "Participants registering at the front desk, ready for the event."
      },
      {
        "id": "foto-6", "title": "Portal 6 Committee", "year": "2024",
        "thumbnailUrl": photo6, "fullUrl": photo6,
        "description": "The dedicated committee of Portal 6 posing for a group photo."
      },
      {
        "id": "foto-7", "title": "Enthusiastic Participants & Speakers", "year": "2024",
        "thumbnailUrl": photo7, "fullUrl": photo7,
        "description": "Speakers and participants sharing a moment of connection."
      }
    ],
    "videos": [
    ]
  },
  "partnersSponsors": [
    {
      "id": "partner-1", "name": "HIMAVO Micro IT", "logoUrl": partnerLogoMicroIT, "type": "media_partner",
      "websiteUrl": "https://www.instagram.com/micro_ipb/?hl=en"
    },
    {
      "id": "partner-2", "name": "HIMAVO LIKISTA", "logoUrl": partnerLogoLikista, "type": "media_partner",
      "websiteUrl": "https://www.instagram.com/likista_ipb/?hl=en"
    },
    {
      "id": "partner-3", "name": "Info SV IPB", "logoUrl": partnerLogoInfoSV, "type": "media_partner",
      "websiteUrl": "https://www.instagram.com/infosvipb/?hl=en"
    },
    {
      "id": "partner-4", "name": "SEI Indonesia", "logoUrl": partnerLogoInfoSEI, "type": "sponsor",
      "websiteUrl": "https://www.seindonesia.co.id/"
    },
    {
      "id": "partner-5", "name": "Smartfren", "logoUrl": partnerLogoSmartfren, "type": "sponsor",
      "websiteUrl": "https://www.smartfren.com/"
    }
  ]
};

export default mediaContent;
